import action from '../commons/appointmentActionStatus';

export const createAppointmentRequestAction = (
    patientId,
    doctorSlotId,
    hospitalId,
    paymentType = 'POSTPAID',
) => {
    return {
        type: action.CREATE_APPOINTMENT_REQUEST,
        status: 'CREATE_APPOINTMENT_REQUEST',
        requestState: true,
        payload: {
            patientId, doctorSlotId, hospitalId, paymentType
        }
    };
};

export const createAppointmentSuccessAction = (result) => {
    return {
        type: action.CREATE_APPOINTMENT_SUCCESS,
        status: 'Appointment created sucessfully',
        result,
        requestState: false,
    };
};

export const createAppointmentFailureAction = (error) => {
    return {
        type: action.CREATE_APPOINTMENT_FAILURE,
        status: 'Appointment creation failure',
        error,
        requestState: false,
    };
};

export const resetAppointmentState = () => {
    return {
        type: action.RESET_APPOINTMENT_STATE
    };
};
